import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "37",
  viewBox: "0 0 28 37",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path d=\"M13.5 5.9825L8.35459 0H0L10.6331 13.0765L19.3834 9.42276L13.5 5.9825Z\" fill=\"#FF5C00\" fill-opacity=\"0.75\"></path><path d=\"M19.4441 0L14 6.26269L18.192 11.9868L19.1462 10.8211L27.9991 0H19.4441Z\" fill=\"#FF5C00\"></path><path d=\"M12.9651 7.10339C12.4298 7.21133 11.9088 7.40357 11.4193 7.67935L2.8083 12.5303C1.07637 13.5063 0 15.3805 0 17.4182V26.5811C0 28.6188 1.07637 30.4938 2.8083 31.469L11.4193 36.3207C13.0281 37.2264 14.9719 37.2264 16.5779 36.3207L25.1917 31.469C25.9761 31.0269 26.6259 30.4007 27.1011 29.6583C27.6765 28.7615 28 27.6953 28 26.5811V17.4182C28 15.3805 26.9236 13.5063 25.1917 12.5303L16.5779 7.67935C15.4614 7.04941 14.1818 6.85792 12.9651 7.10339Z\" fill=\"url(#paint0_linear_698_91758)\"></path><path d=\"M11.0682 19.556C11.1082 18.756 11.3882 18.14 11.9082 17.708C12.4362 17.268 13.1282 17.048 13.9842 17.048C14.5682 17.048 15.0682 17.152 15.4842 17.36C15.9002 17.56 16.2122 17.836 16.4202 18.188C16.6362 18.532 16.7442 18.924 16.7442 19.364C16.7442 19.868 16.6122 20.296 16.3482 20.648C16.0922 20.992 15.7842 21.224 15.4242 21.344V21.392C15.8882 21.536 16.2482 21.792 16.5042 22.16C16.7682 22.528 16.9002 23 16.9002 23.576C16.9002 24.056 16.7882 24.484 16.5642 24.86C16.3482 25.236 16.0242 25.532 15.5922 25.748C15.1682 25.956 14.6562 26.06 14.0562 26.06C13.1522 26.06 12.4162 25.832 11.8482 25.376C11.2802 24.92 10.9802 24.248 10.9482 23.36H12.5802C12.5962 23.752 12.7282 24.068 12.9762 24.308C13.2322 24.54 13.5802 24.656 14.0202 24.656C14.4282 24.656 14.7402 24.544 14.9562 24.32C15.1802 24.088 15.2922 23.792 15.2922 23.432C15.2922 22.952 15.1402 22.608 14.8362 22.4C14.5322 22.192 14.0602 22.088 13.4202 22.088H13.0722V20.708H13.4202C14.5562 20.708 15.1242 20.328 15.1242 19.568C15.1242 19.224 15.0202 18.956 14.8122 18.764C14.6122 18.572 14.3202 18.476 13.9362 18.476C13.5602 18.476 13.2682 18.58 13.0602 18.788C12.8602 18.988 12.7442 19.244 12.7122 19.556H11.0682Z\" fill=\"white\"></path><defs><linearGradient id=\"paint0_linear_698_91758\" x1=\"14\" y1=\"7\" x2=\"14\" y2=\"37\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#BB765D\"></stop><stop offset=\"1\" stop-color=\"#9E5F48\"></stop></linearGradient></defs>", 5)
const _hoisted_7 = [
  _hoisted_2
]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MedalBronze',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_7))
}
}

})